import { Heading as HeadingExtension } from '@tiptap/extension-heading';
import { Slice, Fragment, Node as ProseMirrorNode } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export const Heading = HeadingExtension.extend({
  // TODO Remove once headings is supported.
  renderHTML({ HTMLAttributes }) {
    return ['p', HTMLAttributes, 0];
  },
  // TODO Remove once headings is supported.
  addProseMirrorPlugins() {
    const { name: extensionName } = this;

    return [
      new Plugin({
        key: new PluginKey(extensionName),

        props: {
          transformPasted(slice: Slice): Slice {
            const downgradeHeadings = (node: ProseMirrorNode): ProseMirrorNode => {
              const { paragraph } = node.type.schema.nodes;

              if (node.type.name === extensionName) {
                return paragraph.create(node.attrs, node.content, node.marks);
              }

              // Recursively apply to children
              if (node.content.size > 0) {
                const newChildren: ProseMirrorNode[] = [];
                node.content.forEach((child) => {
                  newChildren.push(downgradeHeadings(child));
                });

                return node.copy(Fragment.fromArray(newChildren));
              }

              return node;
            };

            const newChildren: ProseMirrorNode[] = [];
            slice.content.forEach((node) => {
              newChildren.push(downgradeHeadings(node));
            });

            return new Slice(Fragment.fromArray(newChildren), slice.openStart, slice.openEnd);
          },
        },
      }),
    ];
  },
});
